import { TableField } from "@/types/table-field";

const dimensao: TableField = {
  key: "dimensao",
  label: "Dimensão",
  tdClass: ["align-middle"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const item: TableField = {
  key: "itemId",
  label: "Item",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const serigyItem: TableField = {
  key: "serigyItem",
  label: "SerigyItem",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const actions = {
  key: "actions",
  label: "Detalhes",
  tdClass: ["align-middle", "text-left-lg", "w7remlg", "naoQuebrar"],
  thClass: ["text-left", "naoQuebrar"],
  sortable: false,
};

const schema: TableField = {
  key: "serigySchema",
  label: "Schema",
  tdClass: ["align-middle"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const fieldsInvokerRespostas: TableField[] = [
  actions,
  item,
  dimensao,
  serigyItem,
  schema
];
